import { getIsOdd, getIsOnlyReadElement } from '../common/validators';
import {
  formatTagsToString,
  prepareUIElements,
  registerTaskCallbacks,
  setupGlobalHandlers
} from './utils';
import dropdownHTML from '../../components/dropdownHTML/dropdown';
import { TemplateTag } from './TemplateTag';
import { showTagsModal } from '../../../../redux/slices/uiSlice';

const renderTags = (props) => {
  setupGlobalHandlers();

  const { column, gantt, t, onlyRead, task, mainObject, customMainClassName } =
    props;

  if (!gantt || !task) return '';

  const { subtradeRole } = gantt;
  const isOnlyReadElement = getIsOnlyReadElement(onlyRead, task, subtradeRole);
  const selectedObject = { ...task, ...(mainObject || {}) };
  const optionsList = gantt.toSelectTags;

  const searchPlaceholder = formatTagsToString(selectedObject.tags);

  registerTaskCallbacks(task.id, task, {
    column,
    gantt,
    callbackOnSelection: props.handleUpdateTags,
    callbackOnClickCreate: () => {
      gantt.toHardAssignTag = task.id;
      gantt.setVisibleFormTags(true);
      showTagsModal();
    }
  });

  const { placeholderHtml, optionsListHtml, createBtnHtml, removeBtnHtml } =
    prepareUIElements({
      selectedObject,
      optionsList,
      isOnlyReadElement,
      t,
      column,
      taskId: task.id
    });

  const dropdownContent = `
    <ul class="options-list" onscroll="event.stopPropagation()">
      ${createBtnHtml}
      ${optionsListHtml}
      ${removeBtnHtml}
    </ul>
  `;

  const dropdown = dropdownHTML({
    trigger: placeholderHtml,
    content: dropdownContent,
    width: column?.width,
    isReadOnly: isOnlyReadElement,
    id: `tags-dropdown-${task.id}`,
    customClass: `custom-tags-dropdown ${customMainClassName || ''}`,
    searchable: true,
    searchPlaceholder: searchPlaceholder
  });

  const html = `
    <div 
      class="${getIsOdd({ gantt, task }, 'tags') ? 'odd-col' : 'non-odd-col'} ${customMainClassName || ''}"
      data-task-id="${task.id}"
      data-column-name="${column.name}">
      ${dropdown}
      ${TemplateTag(task, gantt)}
    </div>
  `;

  return html;
};

export default renderTags;
